import { UPDATEPROJECTTASK_SUCCESS, UPDATEPROJECTTASK_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateProjectTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEPROJECTTASK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEPROJECTTASK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateProjectTaskReducer;
